import React from 'react';

import { Stages } from '@vk-hr-tek/ui/Stages';
import { useIsDesktop } from '@vk-hr-tek/ui/hooks/media';

import { useSelector } from '../../../../app/hooks';
import { selectStage } from '../../../slice';
import { Page } from '../../../ui/page';

import { ChangePasswordInit } from './ChangePasswordInit';
import { ChangePasswordNewPassword } from './ChangePasswordNewPassword';
import { ChangePasswordVerifyCode } from './ChangePasswordVerifyCode';

const steps = [
  {
    name: 'init',
    content: <ChangePasswordInit />,
    label: 'СНИЛС',
  },
  {
    name: 'verification',
    content: <ChangePasswordNewPassword />,
    label: 'Пароль',
  },
  {
    name: 'finish',
    content: <ChangePasswordVerifyCode />,
    label: 'Смс-код',
  },
];

export const ChangePassword = () => {
  const step = useSelector(selectStage);

  const isDesktop = useIsDesktop();

  return (
    <Page title="Восстановление пароля">
      <Stages
        active={step}
        steps={steps}
        showHeader
        size={isDesktop ? 'medium' : 'small'}
      />
    </Page>
  );
};
